import React from "react";
import { Component } from "react";
import { Form, Button } from "semantic-ui-react";
import PhoneNumber from "awesome-phonenumber";
import PhoneInput, { CountryData } from "react-phone-input-2";

import "react-phone-input-2/lib/style.css";
import { Props } from "../propTypes";
import { childFormComponent } from "./types";
import classnames from "classnames";
import { ProgressIndicator } from "./ProgressIndicator";
import { withCookies } from "react-cookie";
import { ResetForm } from "./ResetForm";
import { customPhoneMasks } from "src/js/constants";

// Name Form Component
/**
 * This component is used to input and store a user's name information in MyElevation.
 *
 * We are using the Form and Button components from Semantic UI React Library.
 * For more information on these components can be found at https://react.semantic-ui.com/collections/form/
 * and https://react.semantic-ui.com/elements/button/
 */

type State = {
    validPhone: boolean;
    showValidation: boolean;
    validEmail: boolean;
    phoneInputContent: string;
};

class ParentInfo extends Component<Props & childFormComponent, State> {
    state = {
        validEmail: false,
        showValidation: false,
        validPhone: false,
        phoneInputContent: "+1",
    };

    // Save and Continue Function
    /**
     * saveAndContinue() saves the values to the state and goes to the corresponding next step.
     */
    saveAndContinue = (e: any) => {
        e.preventDefault();

        if (this.state.validEmail && this.state.validPhone) {
            if (
                this.props.main.searchContactData &&
                this.props.main.searchContactData.data &&
                this.props.main.searchContactData.data[0]
            ) {
                this.props.nextStep(6);
            } else if (this.props.values.campus) {
                this.props.nextStep(6);
            } else {
                this.props.nextStep(11);
            }
        } else {
            this.setState({
                showValidation: true,
            });
        }
    };

    onChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
        const regex = RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        const valid = regex.test(event.target.value);

        this.setState({
            validEmail: valid,
        });

        this.props.handleChange("parentEmail")(event);
    };

    onChangePhone = (
        telNumber: any,
        data: CountryData,
        e,
        formattedPhoneNumber
    ) => {
        const pn = new PhoneNumber(formattedPhoneNumber);
        const valid = pn.isValid() || false;
        if (valid !== this.state.validPhone) {
            this.setState({
                validPhone: valid,
                showValidation: false,
                phoneInputContent: telNumber,
            });
        } else {
            this.setState({ phoneInputContent: telNumber });
        }

        this.props.handleChange("parentPhone")(null, telNumber);
        this.props.handleChange("parentPhoneFormatData")(null, data);
    };

    render() {
        const { values } = this.props;

        return (
            <>
                <div className="col-xs-12 max-w-500 full-width center-content m-y-spacer-3xl">
                    <h2 className="text-dark text-left m-b-spacer-none text-center">
                        Parent or Guardian information
                    </h2>
                    <p className="text-dark half-here  m-b-spacer-lg text-center">
                        We&#39;ll notify them about your signup.
                    </p>

                    <Form
                        className={`parent-info phone-number-form ${
                            this.state.showValidation ? "ec-error" : ""
                        }`}
                    >
                        <Form.Field
                            className={classnames(
                                "label-animation-input rel-pos flex flex-column full-width m-b-spacer-lg ",
                                {
                                    filled: values.parentFirstName,
                                }
                            )}
                        >
                            <label>First Name</label>
                            <input
                                autoFocus={true}
                                className="p-x-spacer-lg no-border ec-border-radius-sm b-width-xs  border-trans-light-grey-alt text-alt-dark-grey full-width"
                                onChange={this.props.handleChange(
                                    "parentFirstName"
                                )}
                                value={values.parentFirstName}
                            />
                        </Form.Field>
                        <Form.Field
                            className={classnames(
                                "label-animation-input rel-pos flex flex-column full-width m-b-spacer-lg ",
                                {
                                    filled: values.parentLastName,
                                }
                            )}
                        >
                            <label>Last Name</label>
                            <input
                                className="p-x-spacer-lg no-border ec-border-radius-sm b-width-xs  border-trans-light-grey-alt text-alt-dark-grey full-width"
                                onChange={this.props.handleChange(
                                    "parentLastName"
                                )}
                                value={values.parentLastName}
                                maxLength={50}
                            />
                        </Form.Field>

                        <Form.Field
                            className={classnames(
                                "flex flex-column full-width m-b-spacer-lg ",
                                {
                                    "ec-error":
                                        this.state.showValidation &&
                                        !this.state.validEmail,
                                }
                            )}
                        >
                            <div
                                className={classnames(
                                    "label-animation-input rel-pos",
                                    {
                                        filled: values.parentEmail,
                                    }
                                )}
                            >
                                <label>Email</label>
                                <input
                                    className="p-x-spacer-lg no-border ec-border-radius-sm b-width-xs  border-trans-light-grey-alt text-alt-dark-grey full-width"
                                    onChange={this.onChangeEmail}
                                    value={values.parentEmail}
                                    maxLength={50}
                                />
                            </div>

                            {this.state.showValidation &&
                            !this.state.validEmail ? (
                                <small className="ec-primary-font ec-line-height">
                                    Please enter a valid email
                                </small>
                            ) : null}
                        </Form.Field>
                        <Form.Field
                            className={classnames(
                                "flex flex-column full-width m-b-spacer-lg ",
                                {
                                    "ec-error":
                                        this.state.showValidation &&
                                        !this.state.validPhone,
                                }
                            )}
                        >
                            <div
                                className={classnames(
                                    "label-animation-input with-phone-field rel-pos ",
                                    {
                                        filled: this.state.phoneInputContent,
                                    }
                                )}
                            >
                                <label className="pull-forward">
                                    Phone Number
                                </label>

                                <PhoneInput
                                    country="us"
                                    preferredCountries={["us"]}
                                    value={values.parentPhone}
                                    inputClass={`full-width`}
                                    inputProps={{
                                        id: "",
                                        autoFocus: false,
                                        autoComplete: "off",
                                    }}
                                    onChange={this.onChangePhone}
                                    isValid={() =>
                                        this.state.showValidation
                                            ? !this.state.validPhone
                                            : true
                                    }
                                    masks={customPhoneMasks}
                                />
                            </div>
                            {this.state.showValidation &&
                            !this.state.validPhone ? (
                                <small className="ec-primary-font ec-line-height">
                                    Please enter a valid Phone Number
                                </small>
                            ) : null}
                        </Form.Field>
                        <Button
                            id={`${this.props.tagPrefixId}-parent-info-next`}
                            className="full-width no-border text-white  p-y-spacer-md uppercase let-sp-reg hover-grow ec-border-radius"
                            onClick={this.saveAndContinue}
                            disabled={
                                !values.parentPhone ||
                                !values.parentEmail ||
                                !values.parentFirstName ||
                                !values.parentLastName
                            }
                        >
                            Next
                        </Button>
                    </Form>
                    <div className="m-t-spacer-lg">
                        <ProgressIndicator currentStep={6} />
                    </div>
                </div>
                <ResetForm
                    idPrefix={`${this.props.tagPrefixId}-parent-info`}
                    cancelUrl={this.props.cancelUrl || ""}
                />
            </>
        );
    }
}

export default withCookies(ParentInfo);
